export default {
    getCounter(state) {
      return state.counter
    }
  }